'use strict';

let isVideoPaused = false;

// Pause videos
$(document).on('click', '.video__controls .pause', () => {
    pauseVideos();
});

// Play videos
$(document).on('click', '.video__controls .play', () => {
    let $steps = $('.step');

    $steps.find('.step__background video').each((i, video) => {
        video.play();
    });

    $steps.find('.video__controls').removeClass('paused');

    isVideoPaused = false;
});

// Restart videos
$(document).on('click', '.video__controls .restart', () => {
    $('.step').find('video').each((i, video) => {
        video.currentTime = 0;
        video.pause();
    });
});

const pauseVideos = () => {
    const $steps = $('.step');

    $steps.find('video').each((i, video) => {
        video.pause();
    });

    $steps.find('.video__controls').addClass('paused');

    isVideoPaused = true;
};

module.exports = {
    pauseVideos,
    isVideoPaused
};
